import { render, staticRenderFns } from "./TableParticipants.vue?vue&type=template&id=b99f00c0"
import script from "./TableParticipants.vue?vue&type=script&lang=js"
export * from "./TableParticipants.vue?vue&type=script&lang=js"
import style0 from "./TableParticipants.vue?vue&type=style&index=0&id=b99f00c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports